import React, { useMemo } from "react";
import TextArea from "@ingka/text-area"
import FormField from "@ingka/form-field";
import Select, { OptGroup, Option } from '@ingka/select';
import 'react-datepicker/dist/react-datepicker.css'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import '@ingka/svg-icon/style.scss';
import '@ingka/button/style.scss';
import '@ingka/forms/style.scss';
import '@ingka/focus/style.scss';
import '@ingka/text/style.scss';
import '../score-access.scss';

interface OptionProps {
  plannedCampaignNos: string,
  handleScoreTypeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void,
  handleExistingProductChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void,
  scoreGroups: Record<string, string>,
  validCampaignNos: string[],
  campaignInputValidFlag: boolean
}

export const ProductInputSection: React.FC<OptionProps> = ({
    plannedCampaignNos,
    handleScoreTypeChange,
    handleExistingProductChange,
    scoreGroups,
    validCampaignNos,
    campaignInputValidFlag
  }) => {
  
  const scoreTypeOptions = useMemo(() => {
    return Object.keys(scoreGroups).map(scoreType =>
      (<Option name={scoreGroups[scoreType]} value={scoreType} data-bucode={scoreType}/>))
  }, [scoreGroups])

  return (
  <div className="scenario-section">
    <FormField
      characterLimit={0}
      valid={campaignInputValidFlag}
      shouldValidate={true}
      validation={{
        id: 'existing-products-msg-id',
        msg: `Valid campaign categories ${validCampaignNos.join(", ")}`,
        type: 'error'
      }}
    >
      <Select
      id='output-level-dropdown'
      label='Prediction Output Level *'
      onChange={handleScoreTypeChange}
      hintText="Select desired model type"
    > 
      <OptGroup>
        {scoreTypeOptions}
      </OptGroup>
    </Select>
      <TextArea
        className="hierarchy-num-input"
        id="existing-id"
        label="Input a comma separated list of pa's, pra's, or hfb's (must match the type selected above) in the planned campaign. Must be in the IKEA catalog *"
        value={plannedCampaignNos}
        onChange={e => handleExistingProductChange(e)}
      />
    </FormField>
  </div>)
}